import { TypeOf, yup } from '@guiker/yup-util'

export const stockIssuerSchema = yup.object({
  name: yup.string().required(),
})

export type StockIssuerSchema = TypeOf<typeof stockIssuerSchema>
